<template>

    <header class="">
        <div class="row">
            <div class="col-lg-2 backwards">
                <span class="hover-active-icon"> <a class="hover-active-icon" @click="$router.go(-1)"><i class="fa fa-angle-left" aria-hidden="true"></i></a></span>

                <img src="https://cloud.perpao.com/files/theme/images/logo/logo.png" class="logo-work" alt="">
                <h5>sofa modules</h5>
            </div>

            <div class="col-lg-6 ">
                <ul class="header-main-menu header-menu">

                   <li v-if="user.role_id > 1">
                    <router-link :to="{ name: 'home' }">Home</router-link>
                </li>
                <li v-if="user.role_id > 1">
                    <router-link :to="{ name: 'shop-product' }">Products</router-link>
                </li>
                <li v-if="user.role_id > 1">
                    <router-link :to="{ name: 'shop-brand' }">Brands</router-link>
                </li>
                <li v-if="user.role_id > 19">
                    <router-link :to="{ name: 'users' }">Sofas</router-link>
                </li>
                <li v-if="user.role_id > 19">
                    <router-link :to="{ name: 'system-files' }">Files</router-link>
                </li>
                
            </ul> 

        </div>
        <div class="col-lg-4 text-right">
            <ul class="header-menu">
                <li>

                    <!--<img class="avatar-header " src="../../assets/img/avatar-user.jpg" alt="">-->
                    <span class="name-header">{{ user.name }} </span>
                </li>

                
                <li class="icon">
                    <router-link :to="{ name: 'logout' }"> 
                        <span>exit</span>
                        <i class="fa fa-sign-out" aria-hidden="true"></i>
                    </router-link>
                </li>
            </ul>

        </div>
    </div>
</header>

</template>

<script>
    import axios from 'axios'

    export default {
        data() {
            return {
                // user: {
                //     name: 'Igor Vinnyk',
                //     status: 'developer',
                //     money: '282.876.00',
                // }
            }
        },
        created() {

            this.$store.dispatch('retrieveUser')
            .then(response => {

            })
            .catch(error => {
            })
        },
        computed: {
            user() {
                return this.$store.getters.getUser
            }
        }
    }
</script>

<style scoped>
header {
    padding: 12px;
    margin-bottom: 20px;
    flex-direction: row;
    justify-content: space-between;
    visibility: visible !important;
    box-sizing: border-box;
    height: 48px;
    min-width: 720px;
    color: #fff;
    border-bottom: 1px solid #e8e8e8;
    background-color: #fff;
    align-items: center;
    -webkit-box-shadow: 0 1px 5px rgba(0,0,0,.05); */
    -moz-box-shadow: 0 1px 5px rgba(0,0,0,.05);
    box-shadow: 0 1px 5px rgba(0,0,0,.05);
}

header h5 {
    display: inline;
    border-left: 1px solid #e8e8e8;
    padding-left: 10px;
}

.backwards span {
    color: #888;
    font-size: 13px;
    padding: 1px 8px 4px 7px;
    border-radius: 3px;
}

.hover-active-icon:hover {
    background-color: #e1e1e1;
    border-color: #e1e1e1;
    color: #333;
    cursor: pointer;
}

.logo-work {
    height: 7px;
    padding-right: 5px;
}

.header-menu {
    display: inline-block;

}
.name-header {
    font-weight: 300;
    color: #333;
    font-size: 12px;
}
.status-header {
    color: #333;
    font-size: 10px;
}
.avatar-header {
    height: 30px;
    float: right;
}
.icon {
    color: #777;
}
.header-main-menu li a {

}
.header-menu a i {
    color: #777;
}

.header-menu li {
    display: inline-block;
    font-size: 15px;
    padding-right: 10px;
}
.header-menu li a {
    display: inline-block;
    color: #304455;
    color: #777;
    font-size:13.5px;
}
.header-menu li i:hover {

    color:#006886!important;
}
.name-header {
    font-weight: bold;
}
.router-link-active {
    color:#17a2b8!important;

}

</style>


// WEBPACK FOOTER //
// src/components/layouts/Header.vue